/* eslint-disable */

import { FC, Suspense, useState } from 'react';
import { Box, Theme, useTheme } from '@mui/material';
import { AgentPermissionsEnum } from 'enums/accessTemplates';

import { SwitchRouter } from 'pages/utils';
import useScreen from 'hooks/useScreen';
import useAuth from 'store/auth';
import usePartners from 'store/partner';
import useMount from 'hooks/useMount';
import HeaderNavigation from 'components/sections/HeaderNavigation';
import SidebarNavigation from 'components/sections/SidebarNavigation/SidebarNavigation';
import ProjectLoading from 'components/sections/ProjectLoading';
import Preloader from 'components/sections/Preloader';
import FooterNavigation from 'components/sections/FooterNavigation';

import routes from './routes';

const sx = (theme: Theme) => ({
  content: {
    [theme.breakpoints.down('md')]: {
      pl: '0px',
    },
    [theme.breakpoints.up('md')]: {
      pl: '300px',
    },
    display: 'flex',
    flexDirection: 'column',
    minHeight: 'calc(100vh - 65px)',
  },
});

const App: FC = () => {
  const theme = useTheme();
  const { isMobile } = useScreen();
  const [open, setOpen] = useState(!isMobile);
  const [authState, authActions] = useAuth();
  const [, partnerActions] = usePartners();

  useMount(() => {
    if (authState.data?.agent?.id) {
      authActions.addWallets();
    }
    partnerActions.get();
  });

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  return (
    <Preloader>
      <Box minHeight="100vh">
        <SidebarNavigation
          open={isMobile ? open : true}
          setOpen={setOpen}
          existPermissions={(authState.data?.agent?.permissions as AgentPermissionsEnum[]) ?? []}
          logoPath={authState.branding?.logo || ''}
        />
        <Box sx={sx(theme).content}>
          <HeaderNavigation setSidebarOpen={handleDrawerOpen} />
          <Box
            width="100%"
            height="100%"
            flexGrow={1}
            sx={{
              [theme.breakpoints.down('sm')]: {
                paddingTop: '65px',
                paddingBottom: '65px',
              },
            }}
          >
            <Suspense fallback={<ProjectLoading isFixed={false} />}>
              <SwitchRouter
                routes={routes}
                existPermissions={(authState?.data?.agent?.permissions as AgentPermissionsEnum[]) ?? []}
              />
            </Suspense>
          </Box>
          <FooterNavigation existPermissions={(authState.data?.agent?.permissions as AgentPermissionsEnum[]) ?? []} />
        </Box>
      </Box>
    </Preloader>
  );
};

export default App;
